import { ApiUtility } from '@codequality/vue-cli-base';

export default class UserApiUtility extends ApiUtility {
  /** APIの基本パス（継承先でこれを変更すれば他のAPIにアクセスできる想定） */
  protected static readonly apiBasePath: string = process.env.VUE_APP_API_ENDPOINT_USER;

  /** 認証/認可トークンキー */
  protected static readonly tokenKey = 'usertoken';

  /** 通信タイムアウトミリ秒 */
  protected static readonly timeoutMs = 600000;
}
